import s from "./MainText.module.scss";
import CountriesButtons from "../CountriesButtons/CountriesButtons";
import { useTranslation } from "react-i18next";

const MainText = () => {
  const { t } = useTranslation();
  return (
    <div className={s.content}>
      <div>
        <div className={s.title}>
          {t(
            "Переезд на работу за границу — сделайте его безопасным и спокойным",
          )}
        </div>

        <div className={s.subtitle}>
          {t(
            "Здесь вы найдёте простые и понятные шаги и рекомендации по медицинским обследованиям, которые помогут вам спланировать трудовую миграцию, учесть требования миграционного законодательства и заранее позаботиться о своём здоровье.",
          )}
        </div>

        <div className={s.subtitle}>
          {t(
            "Особый раздел посвящён людям, живущим с ВИЧ. Мы расскажем, как безопасно планировать поездку, соблюдать законы и получать поддержку на новом месте",
          )}
        </div>
      </div>
    </div>
  );
};

export default MainText;
